import {Notification} from "./notification";
import {ApplicationType} from "../../common/enums/enums";
import {UntypedFormGroup} from "@angular/forms";
import {ResidenzFloor} from "../../common/services/buildings.service";
import {flatMap} from "../../../helpers/collections";
import {BuildingStructure} from '../../buildings/structure/model/building-structure';

export class NotificationForm {
    title: string = null;
    contactId: number = null;
    location?: BuildingStructure = null;
    description?: string = null;
    source?: string = null;
    constructor(form: UntypedFormGroup) {
        Object.keys(this).forEach((field) => {
            this[field] = form.controls[field]?.value;
        });
    }

  toModel(): Notification {
        const application = ApplicationType.BUILDING;
        const {title, contactId, source, description} = this;
        const structureId = this.location.id;
        const locationLabel = this.location.label;
        const buildingId = this.location.buildingStructureId;
        return {application, title, contactId, buildingId, structureId, locationLabel, source, description} as Notification;
    }

}
